import CreateIntegration from 'app/developer-v3/pages/createIntegration';

export default {
  routes: {
    '.': CreateIntegration,
  },
};
